import { isValidElement } from 'react';
import { LoaderOverlay } from '@pocketlaw/tetris';
import { ContentErrorState } from './ContentErrorState';
import { useScreenLayout } from './ScreenLayoutProvider';
import { ContentContainer } from './styled';
function isEmptyStateProps(value) {
    return typeof value === 'object' && value !== null && !isValidElement(value) && !Array.isArray(value);
}
function resolveErrorContent(errorComponent) {
    if (isEmptyStateProps(errorComponent)) {
        return <ContentErrorState {...errorComponent}/>;
    }
    return errorComponent !== null && errorComponent !== void 0 ? errorComponent : <ContentErrorState />;
}
export function Content(props) {
    const { children, errorComponent } = props;
    const { sidebar, state } = useScreenLayout();
    return (<ContentContainer $sidebarOpen={sidebar.isOpen}>
      <LoaderOverlay enabled={state === 'loading'}>
        {state === 'error' && errorComponent !== false ? resolveErrorContent(errorComponent) : children}
      </LoaderOverlay>
    </ContentContainer>);
}
